module.exports = "/images/refund_policy_icon.svg?52eb4e8e2ae144d4d6abb74c062f3efd";